import { useMemo } from 'react';
import { useAppSelector } from './useRedux';

/**
 * Custom hook to get merged customer data with all properties
 * Combines selectedCustomer (basic info) with full customer data from customers array
 * to ensure we have all properties including country, paymentTerm, accountType, etc.
 */
export const useCustomerData = () => {
  const customerState = useAppSelector((state: any) => state?.customer || {});
  const { selectedFreelancersForInvoice = [] } = customerState;
  
  // Memoize the merged customer data to avoid unnecessary recalculations
  const selectedCustomer = useMemo(() => {
    // selectedCustomer only has {id, name, billingAddress, email}
    // Full customer data is in customerState.customers array
    const baseSelectedCustomer = customerState?.selectedCustomer || {};
    const fullCustomerData = customerState?.customers?.find(
      (c: any) => c?.customerId?.toString() === baseSelectedCustomer?.id?.toString() ||
                  c?.fortnoxCustomerId === baseSelectedCustomer?.id
    );
    
    // Merge both objects to ensure we have all properties
    return {
      ...baseSelectedCustomer,
      ...fullCustomerData,
      // Preserve original id format from selectedCustomer
      id: baseSelectedCustomer?.id
    };
  }, [customerState?.selectedCustomer, customerState?.customers]);

  return {
    customerState,
    selectedCustomer,
    selectedFreelancersForInvoice
  };
};
